import { css } from '@compiled/react';
import { UniformSlot, UniformSlotWrapperComponentProps } from '@uniformdev/canvas-react';

import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';

export const UniformJiraTemplatesTabContentSubgridLayout = () => {
	const renderJiraTemplatesTabContent: React.ComponentType<UniformSlotWrapperComponentProps> = ({
		items,
	}) => {
		return (
			<div
				css={css({
					display: 'flex',
					flexDirection: 'column',
					gap: token('space.250'),
					[media.above.md]: {
						display: 'grid',
						margin: 0,
						padding: 0,
						gap: 'var(--cl-gap)',
						width: '100%',
						'--cl-gap': token('space.400'),
						'--width-without-gaps': 'calc(100% - var(--cl-gap) * 7)', // width of only the 8 columns, subtracting the 7 gaps in 8 column layout (of 12)
						'--total-gap-5': 'calc(var(--cl-gap) * 4)', // 4 gaps appear in a 5 column section
						gridTemplateColumns: 'calc(var(--width-without-gaps) * 5 / 8 + var(--total-gap-5)) 1fr',
					},
				})}
			>
				{items}
			</div>
		);
	};

	return (
		<UniformSlot name="jiraTemplatesTabContent" wrapperComponent={renderJiraTemplatesTabContent} />
	);
};

export default UniformJiraTemplatesTabContentSubgridLayout;
